import ACTIONS_TYPES from '../../constants/types';

const setGlobalConfigAction = (params) => {
  return { type: ACTIONS_TYPES.SET_GLOBAL_CONFIG, payload: params };
};

const setGlobalDefaultLanguage = (lng) => {
  return {
    type: ACTIONS_TYPES.SET_GLOBAL_DEFAULT_LANGUAGE,
    payload: lng
  }
}

const setGlobalLanguages = (lngs) => {
  return {
    type: ACTIONS_TYPES.SET_GLOBAL_LANGUAGES,
    payload: lngs
  }
}


export default { setGlobalConfigAction, setGlobalDefaultLanguage, setGlobalLanguages };
